module.exports = __webpack_public_path__ + "img/350x625 Taxi.236448a0.jpg";